import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';

import { WritableDraft } from 'immer';

export const get_entity_with_sorted_tokens_search = (target: DTOSearchSettings | WritableDraft<DTOSearchSettings>) => {
  let tokens = target.tokens.sort(DTO__token.sortByWordTranslated);

  return target.clone({
    tokens,
  });
};
